import React, { useContext } from 'react';
import { DataContext } from 'entries/common/widgets/context';
import { AddToShoppingList as AddToShoppingListCommon } from 'pages/common/components/AddToShoppingList';
import { useIsLaminateCalculator } from 'pages/dimensions/hooks/use-is-laminate-calculator.hook';
import { useToggleCalculationProjectStatus } from './hooks/use-toggle-calculation-project-status';

export const AddToShoppingList = () => {
  const isLaminateCalculator = useIsLaminateCalculator();
  const remoteData = useContext(DataContext);
  const {
    isProjectSaved,
    saveProjectToShoppingList,
    removeProjectFromShoppingList,
  } = useToggleCalculationProjectStatus();

  if (!isLaminateCalculator || !remoteData?.isSaveProjectEnable) {
    return null;
  }

  return (
    <AddToShoppingListCommon
      isProjectSaved={isProjectSaved}
      saveProjectToShoppingList={saveProjectToShoppingList}
      removeProjectFromShoppingList={removeProjectFromShoppingList}
    />
  );
};
